// Sendai indicator filter for the asset-level Sendai dropdown.
//
// Background: the server's /api/types/<enterprise>/sendai_indicator endpoint
// returns rows tagged with that enterprise's type plus the cross-cutting
// ALL-typed ones we seeded in V6 (A1–B5, C1+C3–C6, D1–D7). For most
// enterprise classes the surveyor only cares about a subset of the four
// Sendai groups (A=people, B=buildings/livelihoods, C=economic/agriculture,
// D=critical infrastructure). This module trims the dropdown to that
// subset client-side.
//
// Group mapping is the GUI plan tentative (Q-G6 in docs/GUI_IMPLEMENTATION_PLAN.md);
// Anna can refine. If an enterprise kind isn't listed here, we don't filter
// (safer fallback: show everything).

const ALLOWED_GROUPS = {
    ORDINARY_BUILDING:     ["A", "B"],
    NON_ORDINARY_BUILDING: ["A", "B"],
    FARM:                  ["C"],
    TELECOMMUNICATION:     ["D"],
    ELECTRICAL:            ["D"],
    TRANSPORT:             ["D"],
};

// Sendai indicators are seeded with names like "Deaths (A2)",
// SendaiIndicator enum codes — A1..A3, B1..B5, C1/C3..C6, D1..D7, and the
// agriculture C-2 breakdown C_2C/C_2L/C_2F0/C_2A/C_2FI. The group is the first
// letter of the code. Returns null if no recognisable code.
const extractGroup = (code) => {
    if (!code) return null;
    const letter = code.charAt(0).toUpperCase();
    return /[A-D]/.test(letter) ? letter : null;
};

// sendaiCodes is an array of SendaiIndicator enum names (strings).
export const filterSendaiByEnterprise = (sendaiCodes, enterpriseTypeValue) => {
    const allowed = ALLOWED_GROUPS[enterpriseTypeValue];
    if (!allowed) return sendaiCodes;
    return sendaiCodes.filter(code => {
        const group = extractGroup(code);
        return group && allowed.includes(group);
    });
};
